<div class="indent-item">
    <div class="indent-item-holder">
        <div class="indent-item-btn push-to-dir-btn">
            <rl-arrow-buttons [dir]="'right'" (onClick)="updateLevel(level + 1)" [ngClass]="{'indent-item-blocker' : level == maxLevel}" [tooltip]="'indent.section.dir' | translate" [rlAria]></rl-arrow-buttons>
        </div>
        <div class="indent-item-btn push-to-opp-dir-btn">
            <rl-arrow-buttons [dir]="'left'" (onClick)="updateLevel(level - 1)" [ngClass]="{'indent-item-blocker' : level == minLevel}" [tooltip]="'indent.section.opp.dir' | translate" [rlAria]></rl-arrow-buttons>
        </div>
    </div>
</div>